import { IconsVariant } from "@/Components/Icon/Icon";
import { CountryCode, PaymentMethodEnum } from "./enum";

export type Payment = {
  value: number;
  translationKey: string;
  icon?: IconsVariant;
  countries: number[];
  isOfflinePayment?: boolean;
  isOnlinePayment?: boolean;
  isPosPayment?: boolean;
  isMainPayment?: boolean;
  isKioskPayment?: boolean;
};

export const payments: Payment[] = [
  {
    value: PaymentMethodEnum.CASH,
    translationKey: "cash",
    icon: "money",
    countries: [CountryCode.ALL],
    isPosPayment: true,
    isOfflinePayment: true,
    isMainPayment: true,
  },
  {
    value: PaymentMethodEnum.IDEAL,
    translationKey: "ideal",
    icon: "ideal",
    countries: [CountryCode.NETHERLANDS, CountryCode.BELGIUM],
    isOnlinePayment: true,
    isPosPayment: true,
    isMainPayment: true,
    isKioskPayment: true,
  },
  {
    value: PaymentMethodEnum.DEBIT_CARD,
    translationKey: "pinNotWork",
    icon: "brokenPin",
    countries: [CountryCode.ALL],
    isPosPayment: true,
    isOfflinePayment: true,
    isMainPayment: true,
  },
  {
    value: PaymentMethodEnum.BAN_CONTACT,
    translationKey: "bancontact",
    icon: "banContant",
    countries: [CountryCode.BELGIUM],
    isOnlinePayment: true,
    isPosPayment: true,
    isMainPayment: true,
  },
  {
    value: PaymentMethodEnum.CASH_NOT_EXACT,
    translationKey: "cashNotExact",
    icon: "money",
    countries: [CountryCode.ALL],
  },
  {
    value: PaymentMethodEnum.PAY_CONIQ,
    translationKey: "payconiq",
    icon: "payConiq",
    countries: [CountryCode.BELGIUM],
    isOnlinePayment: true,
    isPosPayment: true,
    isMainPayment: true,
  },
  {
    value: PaymentMethodEnum.DEBIT_CARD_AT_DELIVERY,
    translationKey: "debitcardAtDelivery",
    icon: "creditcard",
    countries: [CountryCode.ALL],
  },
  {
    value: PaymentMethodEnum.PAY_CONIQ_QR_CODE,
    translationKey: "payconfiqQrCode",
    icon: "creditcard",
    countries: [CountryCode.BELGIUM],
  },
  {
    value: PaymentMethodEnum.ONLINE_PAID_IN_EXTERNAL_SYSTEM,
    translationKey: "onlinePaidInExternalSystem",
    icon: "creditcard",
    countries: [CountryCode.ALL],
  },
  {
    value: PaymentMethodEnum.CREDIT_CARD,
    translationKey: "creditcard",
    icon: "creditcard",
    countries: [CountryCode.ALL],
    isOnlinePayment: true,
    isPosPayment: true,
    isMainPayment: true,
  },
  {
    value: PaymentMethodEnum.CREDIT_CARD_POS,
    translationKey: "creditcardPos",
    icon: "creditcard",
    countries: [CountryCode.ALL],
  },
  {
    value: PaymentMethodEnum.PAYPAL,
    translationKey: "paypal",
    icon: "paypal",
    countries: [CountryCode.BELGIUM, CountryCode.NETHERLANDS],
  },
  {
    value: PaymentMethodEnum.INVOICE_LATER,
    translationKey: "invoiceLater",
    icon: "credit",
    countries: [CountryCode.ALL],
    isPosPayment: true,
    isOfflinePayment: true,
    isMainPayment: true,
  },
  {
    value: PaymentMethodEnum.VISA,
    translationKey: "visa",
    icon: "creditcard",
    countries: [CountryCode.ALL],
  },
  {
    value: PaymentMethodEnum.MASTERCARD,
    translationKey: "mastercard",
    icon: "creditcard",
    countries: [CountryCode.ALL],
  },
  {
    value: PaymentMethodEnum.VOUCHER,
    translationKey: "voucher",
    icon: "envelope",
    countries: [CountryCode.ALL],
  },
  {
    value: PaymentMethodEnum.EXPRESS_PAY,
    translationKey: "expressPay",
    icon: "bank",
    countries: [CountryCode.BELGIUM, CountryCode.NETHERLANDS],
  },
  {
    value: PaymentMethodEnum.CHEQUE,
    translationKey: "cheque",
    icon: "envelope",
    countries: [CountryCode.BELGIUM, CountryCode.NETHERLANDS],
  },
  {
    value: PaymentMethodEnum.ONLINE_BANK_TRANSFER,
    translationKey: "onlineBankTransfer",
    icon: "bank",
    countries: [CountryCode.ALL],
  },
  {
    value: PaymentMethodEnum.GIFT_CARD,
    translationKey: "giftCard",
    icon: "creditcard",
    countries: [CountryCode.ALL],
  },
  {
    value: PaymentMethodEnum.POS_TERMINAL,
    translationKey: "startPin",
    icon: "startPin",
    countries: [CountryCode.ALL],
    isPosPayment: true,
  },
  {
    value: PaymentMethodEnum.PAYMENT_METHOD_NOT_KNOWN_YET,
    translationKey: "paymentMethodNotKnownYet",
    icon: "payLater",
    countries: [CountryCode.ALL],
    isPosPayment: true,
  },
  {
    value: PaymentMethodEnum.SPLIT_PAYMENT,
    translationKey: "splitPayment",
    icon: "splitPayment",
    countries: [CountryCode.ALL],
    isPosPayment: true,
  },
  {
    value: PaymentMethodEnum.PLUXEE_ONLINE,
    translationKey: "pluxeeOnline",
    countries: [CountryCode.TURKIYE],
  },
  {
    value: PaymentMethodEnum.SODEXO_CARD_AT_DELIVERY,
    translationKey: "sodexoCardAtDelivery",
    countries: [CountryCode.TURKIYE],
  },
  {
    value: PaymentMethodEnum.MULTINET_ONLINE,
    translationKey: "multinetOnline",
    countries: [CountryCode.TURKIYE],
  },
  {
    value: PaymentMethodEnum.SODEXO_CODE_AT_DELIVERY,
    translationKey: "sodexoCodeAtDelivery",
    countries: [CountryCode.TURKIYE],
  },
  {
    value: PaymentMethodEnum.EDENRED_ONLINE,
    translationKey: "edenredOnline",
    countries: [CountryCode.TURKIYE],
  },
  {
    value: PaymentMethodEnum.MULTINET_CARD_AT_DELIVERY,
    translationKey: "multinetCardAtDelivery",
    countries: [CountryCode.TURKIYE],
  },
  {
    value: PaymentMethodEnum.SETCARD_ONLINE,
    translationKey: "setcardOnline",
    countries: [CountryCode.TURKIYE],
  },
  {
    value: PaymentMethodEnum.MULTINET_CODE_AT_DELIVERY,
    translationKey: "multinetCodeAtDelivery",
    countries: [CountryCode.TURKIYE],
  },
  {
    value: PaymentMethodEnum.EDENRED_CARD_AT_DELIVERY,
    translationKey: "edenredCardAtDelivery",
    countries: [CountryCode.TURKIYE],
  },
  {
    value: PaymentMethodEnum.EDENRED_CODE_AT_DELIVERY,
    translationKey: "edenredCodeAtDelivery",
    countries: [CountryCode.TURKIYE],
  },
  {
    value: PaymentMethodEnum.SETCARD_CARD_AT_DELIVERY,
    translationKey: "setcardCardAtDelivery",
    countries: [CountryCode.TURKIYE],
  },
  {
    value: PaymentMethodEnum.SETCARD_CODE_AT_DELIVERY,
    translationKey: "setcardCodeAtDelivery",
    countries: [CountryCode.TURKIYE],
  },
  {
    value: PaymentMethodEnum.METROPOL_CARD_AT_DELIVERY,
    translationKey: "metropolCardAtDelivery",
    countries: [CountryCode.TURKIYE],
  },
  {
    value: PaymentMethodEnum.METROPOL_CODE_AT_DELIVERY,
    translationKey: "metropolCodeAtDelivery",
    countries: [CountryCode.TURKIYE],
  },
  {
    value: PaymentMethodEnum.TOKENFLEX_MOBILE_AT_DELIVERY,
    translationKey: "tokenflexMobileAtDelivery",
    countries: [CountryCode.TURKIYE],
  },
  {
    value: PaymentMethodEnum.TOKENFLEX_CODE_AT_DELIVERY,
    translationKey: "tokenflexCodeAtDelivery",
    countries: [CountryCode.TURKIYE],
  },
  {
    value: PaymentMethodEnum.PAYEKART_CARD_AT_DELIVERY,
    translationKey: "payekartCardAtDelivery",
    countries: [CountryCode.TURKIYE],
  },
  {
    value: PaymentMethodEnum.PAYEKART_CODE_AT_DELIVERY,
    translationKey: "payekartCodeAtDelivery",
    countries: [CountryCode.TURKIYE],
  },
  {
    value: PaymentMethodEnum.IWALLET_CODE_AT_DELIVERY,
    translationKey: "iwalletCodeAtDelivery",
    countries: [CountryCode.TURKIYE],
  },
  {
    value: PaymentMethodEnum.OTHERWISE,
    translationKey: "otherPaymentMethod",
    icon: "creditcard",
    countries: [CountryCode.TURKIYE],
  },
  {
    value: PaymentMethodEnum.ONLINE,
    translationKey: "online",
    icon: "creditcard",
    countries: [CountryCode.ALL],
  },
];

export const filterPaymentByCountry = (country: number) => {
  return payments.filter(
    (p) =>
      p.countries?.includes(country) || p.countries?.includes(CountryCode.ALL)
  );
};
